import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import BlockIcon from '@mui/icons-material/Block';

function UnauthorizedPage() {
  const navigate = useNavigate();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      minHeight="60vh"
    >
      <BlockIcon color="error" sx={{ fontSize: 60, mb: 2 }} />
      <Typography variant="h4" gutterBottom>
        無訪問權限
      </Typography>
      <Typography variant="body1" color="text.secondary" paragraph>
        很抱歉，您沒有權限訪問此頁面。此功能僅限管理員使用。
      </Typography>
      <Button 
        variant="contained" 
        color="primary" 
        onClick={() => navigate('/')}
      >
        返回首頁
      </Button>
    </Box>
  );
}

export default UnauthorizedPage;